import React, { useRef, useState } from 'react';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { Button, ButtonWithIcon } from '@els/els-react--button';
// @ts-ignore
import { Card } from '@els/els-react--card';
import { useSelector, useDispatch } from 'react-redux';
// @ts-ignore
import { Header } from '@els/els-react--header';
// @ts-ignore
import { Flyout } from '@els/els-react--flyout';
// @ts-ignore
import { NavLink, useHistory } from 'react-router-dom';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
// @ts-ignore
import { ModalPanel } from '@els/els-react--modal-panel';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
// @ts-ignore
import ClinicalSkillsLogo from '../../assets/img/clinical-skills-logo-old-brand.svg';
import {
    selectAsyncStatus,
    selectClientAuthorizedForSkill,
    selectClientFeatureFlags,
    selectEcrId,
    selectFirstName,
    selectLastName,
    selectUserAuthenticationStatus,
    selectUserPermissions,
    selectUserEmail,
} from '../../features/login/login-selector';
import { selectOrganizations } from '../../features/organizations/organizations-selector';
import {
    getActiveOrganization,
    shouldShowChangeLocation,
} from '../../features/organizations/organizations-claim';
// @ts-ignore
import './GeneralHeader.scss';
import {
    selectClientIdByEcrIdAsyncStatus,
    selectIsWhitelistedIp,
    selectReferentialClientAuthorizedForSkill,
} from '../../features/referential-access/referential-access-selector';
import {
    changeOrganizationFlow,
    loginFlow,
    logoutFlow,
} from '../../features/login/login-thunk';
import { USER_ACTION_PERMISSIONS } from '../../../libs/utils/constants/user-action-permissions';
import WithPermissions from '../with-permissions/with-permissions';
import {
    hasSucceeded,
    isPending,
} from '../../../libs/utils/constants/async-status';
import {
    selectAppConfigs,
    selectAppConfigsAsyncStatus,
    selectAppRuntimeConfigsAsyncStatus,
} from '../../features/app-config/app-config-selector';
import { selectTypeOfContentForClientAsyncStatus } from '../../features/home/home-selector';
import { FEATURE_FLAGS } from '../../../libs/utils/constants/feature-flag';
import AccountCenterModal from './user-account-modal/AccountCenterModal';

const GeneralHeader = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileUserModalOpen, setIsMobileUserModalOpen] = useState(false);
    const [openSsoFlyoutId, setOpenSsoFlyoutId] = useState<string | null>(null);
    const [isOrgTooltipVisible, setIsOrgTooltipVisible] = useState(false);
    const ecrId = window.location.pathname.split('/')[1];
    const firstName = useSelector(selectFirstName);
    const lastName = useSelector(selectLastName);
    const userEmail = useSelector(selectUserEmail);
    const isIpWhitelisted = useSelector(selectIsWhitelistedIp);
    const isUserAuthenticated = useSelector(selectUserAuthenticationStatus);
    const asyncStatus = useSelector(selectAsyncStatus);
    const userHasSkillAccess = useSelector(selectClientAuthorizedForSkill);
    const getClientIdByEcrIdAsyncStatus = useSelector(
        selectClientIdByEcrIdAsyncStatus
    );
    const referentialHasSkillAccess = useSelector(
        selectReferentialClientAuthorizedForSkill
    );
    const userPermissions = useSelector(selectUserPermissions);
    const appConfigsAsyncStatus = useSelector(selectAppConfigsAsyncStatus);
    const appRuntimeConfigsAsyncStatus = useSelector(
        selectAppRuntimeConfigsAsyncStatus
    );
    const appConfigs = useSelector(selectAppConfigs);
    const skillExistsAsyncStatus = useSelector(
        selectTypeOfContentForClientAsyncStatus
    );
    const clientFeatureFlags = useSelector(selectClientFeatureFlags);
    const organizations = useSelector(selectOrganizations);
    const ecrIdFromLogin = useSelector(selectEcrId);
    // The organization name comes from the NeoID ID token claim; no (or
    // malformed) claim means no name.
    const organizationName = (
        getActiveOrganization(organizations, ecrIdFromLogin)?.name || ''
    ).trim();
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    const userInitials = `${(firstName || '').charAt(0)} ${(
        lastName || ''
    ).charAt(0)}`.trim();

    const adminRef = useRef<HTMLDivElement>(null);
    const [ariaRef, setAriaRef] = useState(false);
    const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);

    const handleSkillsReferenceLinksDownloadReport = () => {
        window.open(`${REPORTS_BASE_URL}/skills-reference-link`, '_blank');
    };

    const hasRuntimeConfigs =
        isUserAuthenticated &&
        hasSucceeded(appRuntimeConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0;

    const NEURON_BASE_URL = hasRuntimeConfigs ? appConfigs.NEURON_BASE_URL : '';

    const REPORTS_BASE_URL = hasRuntimeConfigs
        ? `${appConfigs.REPORTS_BASE_URL}/ecl-reports`
        : '';

    const AXON_BASE_URL = hasRuntimeConfigs ? appConfigs.AXON_BASE_URL : '';

    const POINT_OF_CARE_BASE_URL =
        hasSucceeded(appConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0
            ? appConfigs.POINT_OF_CARE_BASE_URL
            : '';

    const SENSE_BASE_URL = hasRuntimeConfigs ? appConfigs.SENSE_BASE_URL : '';

    const navItemList = [
        {
            label: 'Home',
            key: 'HOME',
            navigateTo: `/${ecrId}/home`,
            requiredPermission: null,
        },
        {
            label: 'Search',
            key: 'SEARCH',
            navigateTo: `/${ecrId}/search`,
            requiredPermission: null,
        },
    ];
    const adminNavItemList = [
        {
            label: 'Admin center',
            key: 'ADMIN_CENTER',
            requiredPermission: null,
            isDropdown: true,
            secondaryNavItems: [
                {
                    label: 'Reports',
                    key: 'REPORTS',
                    navigateTo: `${REPORTS_BASE_URL}/reports`,
                    requiredPermission:
                        USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                    tertiaryNavItems: [
                        {
                            label: 'Assignment progress',
                            key: 'ASSIGNMENT_PROGRESS',
                            navigateTo: `${REPORTS_BASE_URL}/assignment-progress`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                        },
                        {
                            label: 'Learner progress',
                            key: 'LEARNER_PROGRESS',
                            navigateTo: `${REPORTS_BASE_URL}/learner-progress`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                        },
                        {
                            label: 'Skills checklist progress',
                            key: 'SKILLS_CHECKLIST_PROGRESS',
                            navigateTo: `${REPORTS_BASE_URL}/skills-checklist-progress`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                        },
                        {
                            label: 'Organization progress',
                            key: 'ORGANIZATION_PROGRESS',
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                            navigateTo: `${REPORTS_BASE_URL}/organization-progress`,
                        },
                        {
                            label: 'Top viewed skills',
                            key: 'TOP_VIEWED_SKILLS',
                            navigateTo: `${REPORTS_BASE_URL}/top-viewed-skills`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                        },
                        {
                            label: 'Download skills reference links',
                            key: 'SKILLS_REFERENCE_LINKS',
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.VIEW_REPORTS_PAGE,
                            navigateTo: '#',
                        },
                        {
                            label: 'Learner satisfaction',
                            key: 'LEARNER_SATISFACTION',
                            requiredPermission: null,
                            navigateTo: `${REPORTS_BASE_URL}/satisfaction-scores`,
                            requiredFeatureFlag:
                                FEATURE_FLAGS.ENABLE_SENSE_ACCESS,
                        },
                    ],
                },
                {
                    label: 'Surveys and journals',
                    key: 'SURVEYS_AND_JOURNALS',
                    navigateTo: `${REPORTS_BASE_URL}/surveys-journals`,
                    requiredPermission: null,
                    requiredFeatureFlag: FEATURE_FLAGS.ENABLE_SENSE_ACCESS,
                },
                {
                    label: 'People',
                    key: 'PEOPLE',
                    navigateTo: `${AXON_BASE_URL}/users`,
                    requiredPermission: null,
                },
                {
                    label: 'Manage assignments',
                    key: 'MANAGE_ASSIGNMENTS',
                    navigateTo: `${AXON_BASE_URL}/education/assignments`,
                    requiredPermission:
                        USER_ACTION_PERMISSIONS.VIEW_EDUCATION_PAGE,
                },
                {
                    label: 'Customize',
                    key: 'CUSTOMIZE',
                    requiredPermission:
                        USER_ACTION_PERMISSIONS.CREATE_EDIT_CUSTOM_EDUCATION,
                    disabled: true,
                    tertiaryNavItems: [
                        {
                            label: 'Customize lessons',
                            key: 'CUSTOMIZE_LESSONS',
                            navigateTo: `${AXON_BASE_URL}/education/custom-education`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.CREATE_EDIT_CUSTOM_EDUCATION,
                        },
                        {
                            label: 'Customize skills',
                            key: 'CUSTOMIZE_SKILLS',
                            navigateTo: `${AXON_BASE_URL}/customize-skills`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.CREATE_EDIT_CUSTOM_EDUCATION,
                        },
                        {
                            label: 'Manage customized skills updates',
                            key: 'MANAGE_CUSTOMIZED_SKILLS_UPDATES',
                            navigateTo: `${AXON_BASE_URL}/skills/monthly-content-updates`,
                            requiredPermission:
                                USER_ACTION_PERMISSIONS.CREATE_EDIT_CUSTOM_EDUCATION,
                        },
                    ],
                },
            ],
        },
    ];

    const handleLogin = () => {
        dispatch(loginFlow());
    };

    const onLogoutHandler = () => {
        localStorage.removeItem('IS_USER_AUTHENTICATED');
        dispatch(logoutFlow());
    };

    const onManageAccountHandler = () => {
        if (appConfigs.MYACCOUNT_BASE_URL) {
            window.open(
                appConfigs.MYACCOUNT_BASE_URL,
                '_blank',
                'noopener,noreferrer'
            );
        }
    };

    // Redirects to NeoID's Organization Picker (ELP-67084).
    const onChangeLocationHandler = () => {
        dispatch(changeOrganizationFlow());
    };

    const canChangeLocation = shouldShowChangeLocation(
        clientFeatureFlags[FEATURE_FLAGS.ENABLE_ADVANCED_SSO_ACCOUNT_CENTER] ===
            true,
        organizations
    );

    const MAX_ORG_NAME_CHARS = 21;
    const getTruncatedOrgName = (value: string) =>
        value.length > MAX_ORG_NAME_CHARS
            ? `${value.slice(0, MAX_ORG_NAME_CHARS).trimEnd()}...`
            : value;
    const shouldShowOrgNameTooltip =
        organizationName.length > MAX_ORG_NAME_CHARS;

    const isExternalUrl = (url: string) =>
        url.startsWith('http://') || url.startsWith('https://');

    const onKeyDownMenuItem = (
        e: React.KeyboardEvent,
        navigateTo: string,
        externalUrlCheck: boolean
    ) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (externalUrlCheck) {
                window.location.href = navigateTo;
            } else {
                history.push(navigateTo);
            }
        }
    };

    const navItem = ({ key, navigateTo, label, ParentElement = 'li' }: any) => {
        const isActive = window.location.pathname === navigateTo;
        return (
            <ParentElement
                className="general-header__general-nav__list-item"
                key={`${key}`}
            >
                {(() => {
                    if (label === 'Download skills reference links') {
                        return (
                            <a
                                href={navigateTo}
                                className={
                                    isActive
                                        ? 'general-header__general-nav__list-item__link__active'
                                        : 'general-header__general-nav__list-item__link'
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSkillsReferenceLinksDownloadReport();
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleSkillsReferenceLinksDownloadReport();
                                    }
                                }}
                                aria-label="Skills reference links CSV download"
                            >
                                {label}
                            </a>
                        );
                    }
                    if (label === 'Customize') {
                        return (
                            <span className="general-header__general-nav__list-item__link-disabled">
                                {label}
                            </span>
                        );
                    }
                    return isExternalUrl(navigateTo) ? (
                        <a
                            href={navigateTo}
                            className={
                                isActive
                                    ? 'general-header__general-nav__list-item__link__active'
                                    : 'general-header__general-nav__list-item__link'
                            }
                            onKeyDown={(e) => {
                                onKeyDownMenuItem(e, navigateTo, true);
                            }}
                        >
                            {label}
                        </a>
                    ) : (
                        <NavLink
                            to={navigateTo}
                            className={
                                isActive
                                    ? 'general-header__general-nav__list-item__link__active'
                                    : 'general-header__general-nav__list-item__link'
                            }
                            onKeyDown={(e) => {
                                onKeyDownMenuItem(e, navigateTo, false);
                            }}
                        >
                            {label}
                        </NavLink>
                    );
                })()}
            </ParentElement>
        );
    };

    const signedOutNavItem = ({ key, navigateTo, label }: any) => (
        <li
            className={
                isMobileMenuOpen
                    ? 'general-header__mobile-menu-panel__signed-out-nav__list-item'
                    : 'general-header__signed-out-nav__list-item'
            }
            key={`${key}`}
        >
            {(() => {
                if (label === 'Home') {
                    return renderSignedOutNavLink('Home');
                }
                if (label === 'Search') {
                    return renderSignedOutNavLink('Search');
                }
                return (
                    <NavLink
                        to={navigateTo}
                        className={
                            isMobileMenuOpen
                                ? 'general-header__mobile-menu-panel__signed-out-nav__list-item'
                                : 'general-header__signed-out-nav__list-item__link'
                        }
                    >
                        {label}
                    </NavLink>
                );
            })()}
        </li>
    );

    const handleKeyPress = (tertiary: any, e: React.KeyboardEvent) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            e.stopPropagation();
        } else {
            return;
        }

        const navItems = Array.from(
            adminRef.current?.querySelectorAll(
                '.general-header__general-nav__list-item'
            ) || []
        );
        const currentIndex = navItems.findIndex(
            (el) => el.getAttribute('data-nav-key') === `${tertiary.key}`
        );

        const focusedIndex = navItems.findIndex((el) =>
            el.contains(document.activeElement)
        );

        const currentFocusIndex =
            focusedIndex !== -1 ? focusedIndex : currentIndex;

        let nextIndex = currentFocusIndex;
        if (e.key === 'ArrowDown') {
            nextIndex = (currentFocusIndex + 1) % navItems.length;
        } else if (e.key === 'ArrowUp') {
            nextIndex =
                (currentFocusIndex - 1 + navItems.length) % navItems.length;
        }

        let focusable: HTMLElement | null = null;
        let attempts = 0;
        while (attempts < navItems.length) {
            const candidate = navItems[nextIndex];
            focusable = candidate?.querySelector(
                'a, button, div[tabindex="0"]'
            );
            const hasDisabledClass = !!candidate?.querySelector(
                '.disabled, [class$="disabled"]'
            );
            if (hasDisabledClass) {
                nextIndex =
                    e.key === 'ArrowDown'
                        ? (nextIndex + 1) % navItems.length
                        : (nextIndex - 1 + navItems.length) % navItems.length;
                attempts += 1;
            } else {
                break;
            }
        }
        if (focusable) {
            focusable.focus();
        }
    };

    const adminAriaLabel = () => {
        if (ariaRef) {
            return isAdminMenuOpen ? ' button,' : ' button';
        }
        return '';
    };

    const renderAdminCenterDropdown = (itemDetails: any) => (
        <li key={itemDetails.key}>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
                className="general-header__general-nav__list-item"
                data-nav-key={itemDetails.key}
                ref={adminRef}
                onKeyDown={(e) => handleKeyPress(itemDetails, e)}
            >
                <Flyout
                    id="admin-center-dropdown"
                    className="admin-center-dropdown"
                    flyout={
                        <div className="admin-center-dropdown__content">
                            <ul>
                                {itemDetails.secondaryNavItems
                                    .filter((subItem: any) => {
                                        // Filter out items based on feature flags
                                        if (subItem.requiredFeatureFlag) {
                                            return (
                                                clientFeatureFlags[
                                                    subItem.requiredFeatureFlag
                                                ] === true
                                            );
                                        }
                                        return true;
                                    })
                                    .map((subItem: any) =>
                                        subItem.requiredPermission ? (
                                            <WithPermissions
                                                shouldHide
                                                key={subItem.key}
                                                permissions={[
                                                    subItem.requiredPermission,
                                                ]}
                                                navigateTo={subItem.navigateTo}
                                                label={subItem.label}
                                                render={(props: any) => (
                                                    <li className="admin-center-dropdown__content__secondary-item">
                                                        {navItem({
                                                            ...props,
                                                            ParentElement:
                                                                'div',
                                                        })}

                                                        {(subItem.label ===
                                                            'Reports' ||
                                                            subItem.key ===
                                                                'REPORTS' ||
                                                            subItem.label ===
                                                                'Customize' ||
                                                            subItem.key ===
                                                                'CUSTOMIZE') &&
                                                            Array.isArray(
                                                                subItem.tertiaryNavItems
                                                            ) && (
                                                                <ul className="admin-center-dropdown__content__tertiary-list">
                                                                    {subItem.tertiaryNavItems
                                                                        .filter(
                                                                            (
                                                                                tertiary: any
                                                                            ) => {
                                                                                if (
                                                                                    tertiary.requiredFeatureFlag
                                                                                ) {
                                                                                    return (
                                                                                        clientFeatureFlags[
                                                                                            tertiary
                                                                                                .requiredFeatureFlag
                                                                                        ] ===
                                                                                        true
                                                                                    );
                                                                                }
                                                                                return true;
                                                                            }
                                                                        )
                                                                        .map(
                                                                            (
                                                                                tertiary: any
                                                                            ) =>
                                                                                tertiary.requiredPermission ? (
                                                                                    <WithPermissions
                                                                                        shouldHide
                                                                                        permissions={[
                                                                                            tertiary.requiredPermission,
                                                                                        ]}
                                                                                        key={
                                                                                            tertiary.key
                                                                                        }
                                                                                        navigateTo={
                                                                                            tertiary.navigateTo
                                                                                        }
                                                                                        label={
                                                                                            tertiary.label
                                                                                        }
                                                                                        render={
                                                                                            navItem
                                                                                        }
                                                                                    />
                                                                                ) : (
                                                                                    navItem(
                                                                                        tertiary
                                                                                    )
                                                                                )
                                                                        )}
                                                                </ul>
                                                            )}
                                                    </li>
                                                )}
                                            />
                                        ) : (
                                            <li
                                                key={subItem.key}
                                                className="admin-center-dropdown__content__secondary-item"
                                            >
                                                {navItem({
                                                    ...subItem,
                                                    ParentElement: 'div',
                                                })}

                                                {(subItem.label === 'Reports' ||
                                                    subItem.key === 'REPORTS' ||
                                                    subItem.label ===
                                                        'Customize' ||
                                                    subItem.key ===
                                                        'CUSTOMIZE') &&
                                                    Array.isArray(
                                                        subItem.tertiaryNavItems
                                                    ) && (
                                                        <ul className="admin-center-dropdown__content__tertiary-list">
                                                            {subItem.tertiaryNavItems
                                                                .filter(
                                                                    (
                                                                        tertiary: any
                                                                    ) => {
                                                                        if (
                                                                            tertiary.requiredFeatureFlag
                                                                        ) {
                                                                            return (
                                                                                clientFeatureFlags[
                                                                                    tertiary
                                                                                        .requiredFeatureFlag
                                                                                ] ===
                                                                                true
                                                                            );
                                                                        }
                                                                        return true;
                                                                    }
                                                                )
                                                                .map(
                                                                    (
                                                                        tertiary: any
                                                                    ) =>
                                                                        tertiary.requiredPermission ? (
                                                                            <WithPermissions
                                                                                shouldHide
                                                                                permissions={[
                                                                                    tertiary.requiredPermission,
                                                                                ]}
                                                                                key={
                                                                                    tertiary.key
                                                                                }
                                                                                navigateTo={
                                                                                    tertiary.navigateTo
                                                                                }
                                                                                label={
                                                                                    tertiary.label
                                                                                }
                                                                                render={
                                                                                    navItem
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            navItem(
                                                                                tertiary
                                                                            )
                                                                        )
                                                                )}
                                                        </ul>
                                                    )}
                                            </li>
                                        )
                                    )}
                            </ul>
                        </div>
                    }
                    onToggle={(state: boolean) => {
                        setAriaRef(true);
                        setIsAdminMenuOpen(state);
                    }}
                    shouldCloseOnESC
                    width="340px"
                >
                    <ButtonWithIcon
                        aria-label={`Admin Center Menu${adminAriaLabel()}`}
                        sprite={
                            isAdminMenuOpen
                                ? Icon.Sprites.CHEVRON_UP
                                : Icon.Sprites.CHEVRON_DOWN
                        }
                        className="general-header__admin-center admin-center-dropdown__button"
                        onFocus={() => {
                            setAriaRef(false);
                        }}
                        onBlur={() => {
                            setAriaRef(false);
                        }}
                        type={ButtonWithIcon.Types.BORDERLESS}
                        iconRight
                    >
                        {itemDetails.label || 'Admin center'}
                    </ButtonWithIcon>
                </Flyout>
            </div>
        </li>
    );

    const renderNavItems = (list: any) =>
        list
            .filter((itemDetails: any) => {
                if (itemDetails.secondaryNavItems) {
                    itemDetails.secondaryNavItems =
                        itemDetails.secondaryNavItems
                            .filter((subItem: any) => {
                                if (subItem.requiredFeatureFlag) {
                                    return (
                                        clientFeatureFlags[
                                            subItem.requiredFeatureFlag
                                        ] === true
                                    );
                                }
                                return true;
                            })
                            .map((subItem: any) => {
                                if (
                                    (subItem.key === 'REPORTS' ||
                                        subItem.key === 'CUSTOMIZE') &&
                                    Array.isArray(subItem.tertiaryNavItems)
                                ) {
                                    subItem.tertiaryNavItems =
                                        subItem.tertiaryNavItems.filter(
                                            (tertiary: any) => {
                                                if (
                                                    tertiary.requiredFeatureFlag
                                                ) {
                                                    return (
                                                        clientFeatureFlags[
                                                            tertiary
                                                                .requiredFeatureFlag
                                                        ] === true
                                                    );
                                                }
                                                return true;
                                            }
                                        );
                                }
                                return subItem;
                            });
                }
                return true;
            })
            .map((itemDetails: any) => {
                if (itemDetails.isDropdown) {
                    return renderAdminCenterDropdown(itemDetails);
                }
                return itemDetails.requiredPermission ? (
                    <WithPermissions
                        shouldHide
                        permissions={[itemDetails.requiredPermission]}
                        key={itemDetails.key}
                        navigateTo={itemDetails.navigateTo}
                        label={itemDetails.label}
                        render={navItem}
                    />
                ) : (
                    navItem(itemDetails)
                );
            });

    const renderSignedOutNavItems = (list: any) =>
        list.map((itemDetails: any) => signedOutNavItem(itemDetails));

    const renderNeuronNavLink = () =>
        hasRuntimeConfigs && (
            <li className="general-header__general-nav__list-item">
                <a
                    href={`${NEURON_BASE_URL}/my-learning`}
                    className="general-header__general-nav__list-item__link"
                >
                    My learning
                </a>
            </li>
        );

    const renderReflectionNavLink = () =>
        hasRuntimeConfigs &&
        clientFeatureFlags[FEATURE_FLAGS.ENABLE_SENSE_ACCESS] && (
            <li className="general-header__general-nav__list-item">
                <a
                    href={`${SENSE_BASE_URL}/reflection`}
                    className="general-header__general-nav__list-item__link"
                >
                    Reflection
                </a>
            </li>
        );
    const renderSignedOutNavLink = (path: string) => {
        let hrefValue = '';
        if (path === 'Home') {
            hrefValue = `${POINT_OF_CARE_BASE_URL}/${ecrId}/home`;
        } else if (path === 'Search') {
            hrefValue = `${POINT_OF_CARE_BASE_URL}/${ecrId}/search`;
        }
        const isActive =
            window.location.pathname === `/${ecrId}/${path.toLowerCase()}`;
        const activeClass = isActive
            ? 'general-header__signed-out-nav__active'
            : 'general-header__signed-out-nav__list-item__link';
        return (
            <a href={hrefValue} className={`${activeClass}`}>
                {path}
            </a>
        );
    };

    const handleSpaceOrEnterOpenLink =
        (url: string) => (e: React.KeyboardEvent) => {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                window.open(url, '_blank');
            }
        };

    const renderHelpandSupport = () => (
        <div className="general-header__help-and-support-flyout">
            <ul>
                <li>
                    <LinkElement
                        href={`${appConfigs.SUPPORT_HUB_HOME_URL}`}
                        target="_blank"
                        iconSprite="HelpOutlineCircle"
                        iconSize="xs"
                        onKeyDown={handleSpaceOrEnterOpenLink(
                            appConfigs.SUPPORT_HUB_HOME_URL
                        )}
                    >
                        Support Hub
                    </LinkElement>
                </li>
                <li>
                    <LinkElement
                        href={`${appConfigs.SUPPORT_HUB_CONTACT_US_URL}`}
                        target="_blank"
                        iconSprite="Email"
                        iconSize="xs"
                        onKeyDown={handleSpaceOrEnterOpenLink(
                            appConfigs.SUPPORT_HUB_CONTACT_US_URL
                        )}
                    >
                        Contact Us
                    </LinkElement>
                </li>
            </ul>
        </div>
    );

    const renderHelpAndSupportFlyout = () => (
        <Flyout
            id="help-and-support-flyout"
            flyout={renderHelpandSupport()}
            placement={Flyout.placementTypes.BOTTOM_END}
            className="general-header__help-and-support"
            pointerType={Flyout.pointerTypes.PRIMARY}
            shouldCloseOnESC
        >
            <ButtonWithIcon
                a11y={{
                    name: 'help-icon',
                }}
                tabIndex={0}
                id="help-button-icon"
                textAlignment="middle"
                sprite={Icon.Sprites.HELP_OUTLINE_CIRCLE}
                className="general-header__help-and-support-icon"
                aria-label="Help and Support"
                name="Help and Support"
                onClick={() => {}}
                iconOnly
                type={ButtonWithIcon.Types.BORDERLESS}
            >
                Help and Support
            </ButtonWithIcon>
        </Flyout>
    );

    const renderSignIn = () => (
        <div className="general-header__sign-in-button">
            <Button type="primary" size="small" onClick={handleLogin}>
                Sign in
            </Button>
        </div>
    );
    const renderSignInFlyout = () => (
        <Flyout
            id="sign-in-flyout"
            flyout={renderSignIn()}
            placement={Flyout.placementTypes.BOTTOM_END}
            className="sign-in-flyout"
            pointerType={Flyout.pointerTypes.PRIMARY}
            shouldCloseOnESC
        >
            <Icon
                a11y={{
                    name: 'avatar-icon',
                }}
                size="s"
                tabIndex="0"
                id="sign-in-button-icon"
                textAlignment="middle"
                sprite={Icon.Sprites.PERSON}
                className="general-header__sign-in-icon"
                aria-label="Sign In"
                onClick={() => {}}
                expanded
            />
        </Flyout>
    );

    const renderSsoTriggerButton = (
        showOrgName: boolean,
        showOrgIcon: boolean,
        enableDesktopTooltip: boolean,
        onClick?: () => void
    ) => (
        <Button
            type={Button.Types.BORDERLESS}
            className={`general-header__sso-account-trigger general-header__sso-account-trigger__button${
                showOrgName
                    ? ' general-header__sso-account-trigger--desktop'
                    : ' general-header__sso-account-trigger--icon-only'
            }`}
            onClick={onClick}
            aria-label={[organizationName, fullName, 'account menu']
                .filter(Boolean)
                .join(', ')}
        >
            <Card
                className="general-header__sso-account-trigger-card"
                borderWeight="none"
            >
                {showOrgName && organizationName && (
                    <span className="general-header__sso-account-trigger__org-name">
                        {getTruncatedOrgName(organizationName)}
                    </span>
                )}
                <span
                    className="general-header__sso-user-buttons"
                    aria-hidden="true"
                >
                    {showOrgIcon && (
                        <span className="general-header__sso-user-buttons__org-button">
                            <Icon sprite={Icon.Sprites.INSTITUTION} size="s">
                                <span className="u-els-hide-visually">
                                    Organization
                                </span>
                            </Icon>
                        </span>
                    )}
                    <span
                        className={`general-header__sso-user-buttons__user-initials${
                            showOrgIcon
                                ? ''
                                : ' general-header__sso-user-buttons__user-initials--solo'
                        }`}
                    >
                        {userInitials}
                    </span>
                </span>
            </Card>
        </Button>
    );

    const renderSsoAccountFlyout = (
        flyoutId: string,
        showOrgName: boolean,
        showOrgIcon: boolean,
        enableDesktopTooltip: boolean
    ) => {
        const triggerButton = renderSsoTriggerButton(
            showOrgName,
            showOrgIcon,
            enableDesktopTooltip
        );

        const triggerWithTooltip =
            enableDesktopTooltip && shouldShowOrgNameTooltip ? (
                <Flyout
                    id="sso-org-tooltip"
                    className="general-header__sso-org-tooltip"
                    flyout={
                        <div className="general-header__sso-org-tooltip__content">
                            <div className="u-els-hide-visually">
                                Organization name:
                            </div>
                            {organizationName}
                        </div>
                    }
                    trigger="hover"
                    isControlled
                    isOpen={isOrgTooltipVisible && openSsoFlyoutId === null}
                    onToggle={(open: boolean) => setIsOrgTooltipVisible(open)}
                    placement={Flyout.placementTypes.BOTTOM_END}
                    modifiers={[
                        {
                            name: 'offset',
                            options: {
                                offset: [-56, -30],
                            },
                        },
                    ]}
                    shouldCloseOnESC
                >
                    {triggerButton}
                </Flyout>
            ) : (
                triggerButton
            );

        return (
            <Flyout
                id={flyoutId}
                className="general-header__sso-account-flyout"
                isControlled
                isOpen={openSsoFlyoutId === flyoutId}
                onToggle={(isOpen: boolean) => {
                    setOpenSsoFlyoutId((previousFlyoutId) => {
                        if (isOpen) return flyoutId;
                        if (previousFlyoutId === flyoutId) return null;
                        return previousFlyoutId;
                    });
                    if (isOpen) setIsOrgTooltipVisible(false);
                }}
                flyout={
                    <AccountCenterModal
                        id={`${flyoutId}-content`}
                        className="general-header__desktop-user-modal"
                        renderAs="inline"
                        isOpen
                        firstName={firstName}
                        lastName={lastName}
                        userEmail={userEmail}
                        organizationName={organizationName}
                        onChangeLocation={
                            canChangeLocation
                                ? onChangeLocationHandler
                                : undefined
                        }
                        onManageAccount={onManageAccountHandler}
                        onSignOut={onLogoutHandler}
                    />
                }
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [-20, -18],
                        },
                    },
                ]}
                placement={Flyout.placementTypes.BOTTOM_END}
                pointerType={Flyout.pointerTypes.PRIMARY}
                shouldCloseOnESC
                ariaAttribute="haspopup"
            >
                {triggerWithTooltip}
            </Flyout>
        );
    };

    const renderFlyout = () =>
        renderSsoAccountFlyout(
            'sso-account-flyout-desktop',
            true,
            false,
            shouldShowOrgNameTooltip
        );

    const renderSsoTabletNav = () => (
        <nav
            className="general-header__sso-tablet-nav"
            aria-label=" Account navigation"
        >
            <ul className="general-header__general-nav__list">
                {isIpWhitelisted && !isUserAuthenticated ? (
                    <>
                        {hasSkillAccess() &&
                            renderSignedOutNavItems(navItemList)}
                        <li className="general-header__general-nav__list-item">
                            {renderHelpAndSupportFlyout()}
                        </li>
                        <li className="general-header__mobile-nav__list-item">
                            {renderSignInFlyout()}
                        </li>
                    </>
                ) : (
                    <>
                        {hasSkillAccess() && (
                            <>
                                {renderNavItems(navItemList)}
                                {userPermissions.length
                                    ? renderNavItems(adminNavItemList)
                                    : null}
                                {renderNeuronNavLink()}
                                {renderReflectionNavLink()}
                            </>
                        )}
                        <li className="general-header__general-nav__list-item general-header__general-nav__list-item--support-sso">
                            {renderHelpAndSupportFlyout()}
                        </li>
                        <li className="general-header__general-nav__list-item general-header__sso-account-trigger">
                            {renderSsoAccountFlyout(
                                'sso-account-flyout-tablet',
                                false,
                                true,
                                false
                            )}
                        </li>
                    </>
                )}
            </ul>
        </nav>
    );

    const renderHamburgerIcon = () => (
        <div className="general-header__mobile-nav__humberger-menu">
            <ButtonWithIcon
                onClick={() => setIsMobileMenuOpen(true)}
                id="menu-icon"
                sprite={Icon.Sprites.MENU}
                className="general-header__mobile-nav__humberger-menu__icon"
                iconOnly
                type={ButtonWithIcon.Types.BORDERLESS}
            >
                Open side navigation
            </ButtonWithIcon>
            {isMobileMenuOpen && renderMobileMenu()}
        </div>
    );

    const hasSkillAccess = () =>
        (hasSucceeded(asyncStatus) && userHasSkillAccess) ||
        (hasSucceeded(getClientIdByEcrIdAsyncStatus) &&
            referentialHasSkillAccess);

    const renderMobileMenu = () => (
        <ModalPanel
            id="mobile-menu-panel"
            panelPosition="right"
            className="general-header__mobile-menu-panel"
            modalProps={{
                onClose: () => {
                    setIsMobileMenuOpen(false);
                },
                label: 'Navigation menu',
                messages: { CLOSE_MODAL: 'Close side navigation' },
                focusTrapProps: {
                    focusTrapOptions: {
                        initialFocus: '#mobile-menu-panel-overlay-close-button',
                        checkCanFocusTrap: () => Promise.resolve(),
                        delayInitialFocus: false,
                    },
                },
            }}
        >
            {isIpWhitelisted && !isUserAuthenticated ? (
                <div className="general-header__mobile-menu-panel__sign-in">
                    <Button
                        type="link"
                        className="general-header__mobile-menu-panel__sign-in__button"
                        onClick={handleLogin}
                    >
                        Sign in
                    </Button>
                    {renderSignedOutNavItems(navItemList)}
                </div>
            ) : (
                hasSkillAccess() && (
                    <ul className="general-header__mobile-menu-panel__nav">
                        {renderNavItems(navItemList)}
                        {userPermissions.length
                            ? renderNavItems(adminNavItemList)
                            : null}
                        {renderNeuronNavLink()}
                        {renderReflectionNavLink()}
                    </ul>
                )
            )}
        </ModalPanel>
    );

    return (
        <>
            {isPending(skillExistsAsyncStatus) && <Loader isBlocking />}
            <Header
                className="general-header"
                wordmark={
                    <span className="general-header__app-name">
                        <img
                            src={ClinicalSkillsLogo}
                            alt=""
                            className="general-header__app-name__logo u-els-display-none@tablet"
                        />
                        <img
                            src={ClinicalSkillsLogo}
                            alt=""
                            className="general-header__app-name__logo u-els-display-none u-els-display-inline@tablet"
                        />
                        <span className="u-els-hide-visually">
                            Clinical Skills
                        </span>
                    </span>
                }
                wordmarkLink={{
                    href: `${POINT_OF_CARE_BASE_URL}/${ecrId}/home`,
                    'aria-label': 'Clinical Skills home',
                    id: 'clh-home-link',
                }}
                hideTreeAtMobile
                tabindex={0}
            >
                <nav
                    className="general-header__general-nav"
                    aria-label="Main navigation"
                >
                    <ul className="general-header__general-nav__list">
                        {isIpWhitelisted && !isUserAuthenticated ? (
                            <>
                                {hasSkillAccess() && (
                                    <>
                                        {renderSignedOutNavItems(navItemList)}
                                        <li className="general-header__general-nav__list-item">
                                            {renderHelpAndSupportFlyout()}
                                        </li>
                                    </>
                                )}
                                <li className="general-header__mobile-nav__list-item">
                                    {renderSignInFlyout()}
                                </li>
                            </>
                        ) : (
                            <>
                                {hasSkillAccess() && (
                                    <>
                                        {renderNavItems(navItemList)}
                                        {userPermissions.length
                                            ? renderNavItems(adminNavItemList)
                                            : null}
                                        {renderNeuronNavLink()}
                                        {renderReflectionNavLink()}
                                        <li className="general-header__general-nav__list-item">
                                            {renderHelpAndSupportFlyout()}
                                        </li>
                                    </>
                                )}
                                <li className="general-header__general-nav__list-item">
                                    {renderFlyout()}
                                </li>
                            </>
                        )}
                    </ul>
                </nav>
                {renderSsoTabletNav()}
                <nav
                    className="general-header__mobile-nav"
                    aria-label="Mobile navigation"
                >
                    <ul className="general-header__mobile-nav__list general-header__mobile-nav__list--sso">
                        <li className="general-header__mobile-nav__list-item general-header__mobile-nav__list-item--support-sso">
                            {renderHelpAndSupportFlyout()}
                        </li>
                        <li className="general-header__mobile-nav__list-item general-header__mobile-nav__list-item--hamburger-sso">
                            {renderHamburgerIcon()}
                        </li>
                        {isUserAuthenticated && (
                            <li className="general-header__mobile-nav__list-item general-header__mobile-nav__list-item--user-sso">
                                {renderSsoTriggerButton(
                                    false,
                                    true,
                                    false,
                                    () => setIsMobileUserModalOpen(true)
                                )}
                                <AccountCenterModal
                                    id="mobile-user-modal-nav"
                                    className="general-header__mobile-user-modal"
                                    isOpen={isMobileUserModalOpen}
                                    firstName={firstName}
                                    lastName={lastName}
                                    userEmail={userEmail}
                                    organizationName={organizationName}
                                    contentClassName="general-header__account-center-content--mobile"
                                    actionLinksClassName="general-header__account-center-content__action-links--mobile"
                                    onClose={() =>
                                        setIsMobileUserModalOpen(false)
                                    }
                                    onChangeLocation={
                                        canChangeLocation
                                            ? onChangeLocationHandler
                                            : undefined
                                    }
                                    onManageAccount={onManageAccountHandler}
                                    onSignOut={onLogoutHandler}
                                />
                            </li>
                        )}
                    </ul>
                </nav>
            </Header>
        </>
    );
};

export default GeneralHeader;
